export default __webpack_public_path__ + "static/media/raven-logo.c4a0fccd.webp";